import { format } from 'date-fns/format';
import { parseISO } from 'date-fns/parseISO';

export class DateRangeValueConverter {
  toView(dateRange: string) {
    if (!dateRange) {
      return '';
    }
    const dates = dateRange.split(' - ');
    return `${format(parseISO(dates[0]), 'dd.MM.yyyy')} - ${format(parseISO(dates[1]), 'dd.MM.yyyy')}`;
  }
}
